
import { defineComponent } from 'vue';
import AdListItem from '@/ad/mixins/AdListItem';

export default defineComponent({
  mixins: [AdListItem],
  name: 'AdListItemFullscreen',
});
